"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshTokenFlow = exports.setAgentResponseFailure = exports.setError = exports.initLogin = exports.loginError = exports.loggedIn = exports.setAgentResponse = exports.callTealium = exports.REFRESH_TOKEN_FLOW = exports.LOGOUT_HANDLER = exports.REFRESH_TOKEN = exports.SET_ERROR = exports.GLOBAL_LOADING = exports.SIGN_IN_PAGE_LOADED = exports.CALL_TEALIUM = exports.SET_PROPS = exports.GET_TOKEN_FAILURE = exports.GET_TOKEN_SUCCESS = exports.GET_TOKEN_REQUEST = exports.CONFIG_REQUEST_SUCCESS = exports.LOGGED_IN_SUCCESSFULLY = exports.LOGIN_ERROR = exports.LOGGED_IN = exports.INIT_LOGIN = void 0;
var INIT_LOGIN = 'INIT_LOGIN';
exports.INIT_LOGIN = INIT_LOGIN;
var LOGGED_IN = 'LOGGED_IN';
exports.LOGGED_IN = LOGGED_IN;
var LOGIN_ERROR = 'LOGIN_ERROR';
exports.LOGIN_ERROR = LOGIN_ERROR;
var LOGGED_IN_SUCCESSFULLY = 'LOGGED_IN_SUCCESSFULLY';
exports.LOGGED_IN_SUCCESSFULLY = LOGGED_IN_SUCCESSFULLY;
var CONFIG_REQUEST_SUCCESS = 'CONFIG_REQUEST_SUCCESS';
exports.CONFIG_REQUEST_SUCCESS = CONFIG_REQUEST_SUCCESS;
var GET_TOKEN_REQUEST = 'GET_TOKEN_REQUEST';
exports.GET_TOKEN_REQUEST = GET_TOKEN_REQUEST;
var GET_TOKEN_SUCCESS = 'GET_TOKEN_SUCCESS';
exports.GET_TOKEN_SUCCESS = GET_TOKEN_SUCCESS;
var GET_TOKEN_FAILURE = 'GET_TOKEN_FAILURE';
exports.GET_TOKEN_FAILURE = GET_TOKEN_FAILURE;
var SET_PROPS = 'SET_PROPS';
exports.SET_PROPS = SET_PROPS;
var CALL_TEALIUM = 'CALL_TEALIUM';
exports.CALL_TEALIUM = CALL_TEALIUM;
var SIGN_IN_PAGE_LOADED = 'SIGN_IN_PAGE_LOADED';
exports.SIGN_IN_PAGE_LOADED = SIGN_IN_PAGE_LOADED;
var GLOBAL_LOADING = 'GLOBAL_LOADING';
exports.GLOBAL_LOADING = GLOBAL_LOADING;
var SET_ERROR = 'SET_ERROR';
exports.SET_ERROR = SET_ERROR;
var REFRESH_TOKEN = 'REFRESH_TOKEN';
exports.REFRESH_TOKEN = REFRESH_TOKEN;
var LOGOUT_HANDLER = 'LOGOUT_HANDLER';
exports.LOGOUT_HANDLER = LOGOUT_HANDLER;
var REFRESH_TOKEN_FLOW = 'REFRESH_TOKEN_FLOW';
exports.REFRESH_TOKEN_FLOW = REFRESH_TOKEN_FLOW;

var callTealium = function callTealium(data) {
  return {
    type: CALL_TEALIUM,
    payload: data
  };
};

exports.callTealium = callTealium;

var setAgentResponse = function setAgentResponse(agentTokenResponse) {
  return {
    type: GET_TOKEN_SUCCESS,
    payload: agentTokenResponse
  };
};

exports.setAgentResponse = setAgentResponse;

var loggedIn = function loggedIn(data) {
  return {
    type: LOGGED_IN,
    payload: data
  };
};

exports.loggedIn = loggedIn;

var loginError = function loginError(error) {
  return {
    type: LOGIN_ERROR,
    error: error
  };
};

exports.loginError = loginError;

var initLogin = function initLogin() {
  return {
    type: INIT_LOGIN
  };
};

exports.initLogin = initLogin;

var setError = function setError(errorStatusCode, retryAction) {
  return {
    type: SET_ERROR,
    payload: {
      errorStatusCode: errorStatusCode,
      retryAction: retryAction
    }
  };
};

exports.setError = setError;

var setAgentResponseFailure = function setAgentResponseFailure(error) {
  return {
    type: GET_TOKEN_FAILURE,
    payload: error
  };
};

exports.setAgentResponseFailure = setAgentResponseFailure;

var refreshTokenFlow = function refreshTokenFlow(payload) {
  return {
    type: REFRESH_TOKEN_FLOW,
    payload: payload
  };
};

exports.refreshTokenFlow = refreshTokenFlow;